import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { ValuesFilter } from 'src/app/models/filters';

@Component({
  selector: 'app-options-search-filter',
  templateUrl: './options-search-filter.component.html',
  styleUrls: ['./options-search-filter.component.css']
})
export class OptionsSearchFilterComponent implements OnInit{

  @Input() filterName: string;
  @Input() filterTitle: string;
  @Input() filterDescription: string;
  @Input() options: { key: string; label: string }[];
  @Input() clearAction: Observable<void>;

  @Output() filterChanged = new EventEmitter<ValuesFilter | null>();

  optionForm = this.fb.group({
    selected: [null]
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.optionForm.valueChanges.subscribe(() => this.formChanged());
    this.clearAction.subscribe(() => {
      this.optionForm.get('selected').setValue(null);
      this.formChanged();
    });
  }

  formChanged() {
    this.filterChanged.next(this.optionForm.get('selected').value !== null ?
      new ValuesFilter(this.filterName, [this.optionForm.get('selected').value], undefined) : null);
  }
}
